











































import { Component, Vue } from "vue-property-decorator";
import AuditTabPane from "../components/AuditTabPane.vue";
import api from "@/api";
import {
  ActivityApplyDto,
  AuditFlowScope,
  DataDictionaryDtoPagedResultDto,
  TrainRecordDto
} from "@/api/appService";
import AgileAuditTag from "@/components/AgileAuditTag/index.vue";

@Component({
  name: "AuditTabOfActivityApplyCheckIn",
  components: {
    AuditTabPane,
    AgileAuditTag,
  },
  filters: {
    formatType(type: string, typeList: any[]) {
      let result = "";
      typeList.forEach((item) => {
        if (item.value == type) {
          result = item.text;
          return;
        }
      });
      return result;
    },
  },
})
export default class AuditTabOfActivityApplyCheckIn extends Vue {
  tableItems: ActivityApplyDto[] = [];
  typeList: any = [];

  queryForm: any = {
    name: "",
    projectType: "",
  };

  // 获取表数据
  get fetchData() {
    return api.activityApply.getMyAll;
  }

  handleAudit(dto: any) {
    return this.$router.push({
      name: "ActivityCheckInDetail",
      params: {
        id: dto!.id!.toString(),
      },
    });
  }

  // 审核记录
  handleFlowDetail(dto: any) {
    this.$router.push({
      name: "auditFlowDetail",
      params: {
        hostType: AuditFlowScope.ActivityApply,
        hostId: dto.id,
        auditFlowId: dto.auditFlowId,
      },
    });
  }

  handleCountChange(value: number) {
    this.$emit("count-changed", value);
  }
}
